import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Language } from '../core/models/language.model';
import { DocumentsService } from "../core/services/documents.service";
import { FileService } from '../core/services/file.service';
import { LocalizationService } from '../core/services/localization.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {

  documents: Observable<string[]> | undefined;

  constructor(
    private router: Router,
    private documentService: DocumentsService,
    private fileService: FileService,
    private localizationService: LocalizationService
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.documents = this.documentService.getList();
  }

  get isLoading(): boolean {
    return this.localizationService.isLoadingTranslations();
  }

  get language$(): Observable<Language> {
    return this.localizationService.getLanguage();
  }

  downloadFile(documentName: string) {
    this.documentService.getFile(documentName).subscribe((data) => {
      this.fileService.saveFile(data, documentName);
    });
  }

  getFileName(document: string) {
    return document.replace(/\.[^/.]+$/, "");
  }

  goBack() {
    history.back();
  }

}